module.exports = __webpack_public_path__ + "static/img/2-37.b6b6cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-37.png
// module id = YQgd
// module chunks = 15